import apihelper from './apihelper'
import wx from './wx.js'
import config from '../config'
var bmap_geolocation = null;
var bmap_gecoder = null;
const bmap_eventbus = new Vue();

function bdtogd(bd_lng, bd_lat) {
  var X_PI = Math.PI * 3000.0 / 180.0;
  var x = bd_lng - 0.0065;
  var y = bd_lat - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  var gg_lng = z * Math.cos(theta);
  var gg_lat = z * Math.sin(theta);
  return {
    lng: gg_lng,
    lat: gg_lat
  }
}

function gdtobd(gg_lng, gg_lat) {
  var X_PI = Math.PI * 3000.0 / 180.0;
  var x = gg_lng,
    y = gg_lat;
  var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
  var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
  var bd_lng = z * Math.cos(theta) + 0.0065;
  var bd_lat = z * Math.sin(theta) + 0.006;
  return {
    lat: bd_lat,
    lng: bd_lng
  };
}

export default {
  loadScript(name, url) {
    return new Promise((reslove, reject) => {
      if (!window[name]) {
        var script = document.createElement("script");
        script.src = url;
        script.type = 'text/javascript';
        script.onload = () => {
          reslove();
        }
        document.body.append(script);
      } else {
        reslove();
      }
    })
  },
  loadBMapScript() {
    return new Promise((reslove, reject) => {
      if (!window["BMap"]) {
        window["bmapinit"] = () => {
          config.bMap.eventbus.$emit("bmap_init");
          reslove();
        }
        var script = document.createElement("script");
        script.src = `https://api.map.baidu.com/api?v=3.0&ak=${config.bMap.ak}&callback=bmapinit`;
        script.type = 'text/javascript'
        document.body.append(script);
      } else {
        reslove();
      }
    })
  },
  getGPS() {
    if (config.wx.isWXMini) {
      return wx.getLocation();
    } else {
      return new Promise((resovle, reject) => {
        var that = this;
        if (bmap_geolocation == null) {
          bmap_geolocation = new BMap.Geolocation();
        }

        bmap_geolocation.getCurrentPosition(function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            resovle(r);
          } else if (this.getStatus() == BMAP_STATUS_PERMISSION_DENIED) {
            reject("没有权限")
          } else {
            reject("定位失败");
          }
        }, {
          enableHighAccuracy: true
        })
      })
    }
  },
  getAddress(point) {
    return new Promise((resolve, reject) => {
      if (!bmap_gecoder) {
        bmap_gecoder = new BMap.Geocoder();
      }

      bmap_gecoder.getLocation(point, function(rs) {
        resolve(rs);
      });
    })
  },
  getPoint(address) {
    return new Promise((resolve, reject) => {
      if (!bmap_gecoder) {
        bmap_gecoder = new BMap.Geocoder();
      }

      bmap_gecoder.getPoint(address, function(rs) {
        resolve(rs);
      });
    })
  },
  loadMarkerClu() {
    if (window["BMapLib"] && window["BMapLib"]["TextIconOverlay"]) {
      Promise.resolve();
    } else {
      return Promise.all([
        this.loadScript('BMapLib', '/static/js/markerClusterer.js'),
        this.loadScript('BMapLib.TextIconOverlay', '/static/js/TextIconOverlay.js')
      ]);
    }
  },
  bdtogd: bdtogd,
  gdtobd: gdtobd
}
